// components/InfoRow.js
import React from "react";
import SC from "./style"; // assuming same SC object is accessible

const InfoRow = ({ label, value, isDate, maxLength = 35, children }) => {
  const renderValue = () => {
    if (children) return children; // e.g., <TimezoneConverter />

    if (!value) return "N/A";

    if (typeof value === "string" && value.length > maxLength) {
      return value.slice(0, maxLength) + "...";
    }

    return value;
  };

  return (
    <SC.RowStyle>
      <SC.LabelContainerStyle>{label}</SC.LabelContainerStyle>
      <SC.ValueContainerStyle title={value}>
        {renderValue()}
      </SC.ValueContainerStyle>
    </SC.RowStyle>
  );
};

export default InfoRow;
